<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>数据来源统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title" style="float: right">用户名:</div>
            <div class="flex1" style="float: right">
              <el-input size="small" clearable v-model="queryInfo.userName"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="float: right">操作时间:</div>
            <div class="flex1" style="float: right">
              <el-date-picker
                  v-model="time"
                  type="daterange"
                  range-separator="-"
                  size="small"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title" style="float: right">设备类型:</div>
            <div class="flex1" style="float: right">
              <el-select size="small" clearable v-model="queryInfo.from" placeholder="请选择">
                <el-option
                    v-for="item in fromList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title" style="float: right">操作类型:</div>
            <div class="flex1" style="float: right">
              <el-select size="small" clearable v-model="queryInfo.operation" placeholder="请选择">
                <el-option
                    v-for="item in operationList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="3" class="display-row">
            <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="checkCountList"
        border
        height="500">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="userName" align="center" label="用户名"></el-table-column>
          <el-table-column prop="createTime" align="center" label="操作时间">
            <template v-slot="{row}">
              {{ row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="from" align="center" label="设备类型">
            <template v-slot="{row}">
              {{ fromObj[row.from] }}
            </template>
          </el-table-column>
          <el-table-column prop="device" align="center" label="操作设备"></el-table-column>
          <el-table-column prop="model" align="center" label="操作设备型号"></el-table-column>
          <el-table-column prop="operation" align="center" label="操作类型">
            <template v-slot="{row}">
              {{ operationObj[row.operation] }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'SourceEquipment',
  components: { tableCon },
  data() {
    return {
      queryInfo: {
        userName: '',
        from: '',
        operation: '',
        pageSize: 20,
        pageNum: 1
      },
      time: [],
      total: 0,
      checkCountList: [],
      fromList: [
        {
          label: 'PC',
          value: '0',
        },
        {
          label: 'H5',
          value: '1',
        },
      ],
      operationList: [
        {
          label: '发消息',
          value: '0',
        },
        {
          label: '订单支付',
          value: '1',
        },
        {
          label: '账单支付',
          value: '2',
        },
        {
          label: '充值',
          value: '3',
        },
        {
          label: '登录',
          value: '4',
        }
      ],
      fromObj: {
        0: 'PC',
        1: 'H5',
      },
      operationObj: {
        0: '发消息',
        1: '订单支付',
        2: '账单支付',
        3: '充值',
        4: '登录',
      }
    };
  },
  methods: {
    searchList() {
      //查询
      this.queryInfo.pageNum = 1
      this.getCheckCountList();
    },
    async getCheckCountList() {
      //获取信息列表
      const params = {
        ...this.queryInfo,
        startDate: this.time ? this.time[0] : undefined,
        endDate: this.time ? this.time[1] : undefined,
      }
      this.$http.get('/action/list', {
        params,
      }).then(res => {
        console.log(res,111)
        this.checkCountList = res.data.data.list
        this.total = res.data.data.total;
      })
    },
    queryInfoClear() {
      //清空
      this.queryInfo.userName = ''
      this.time = []
      this.queryInfo.from = ''
      this.queryInfo.operation = ''
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getCheckCountList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getCheckCountList();
    },
  },
  created() {
    this.getCheckCountList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
.query-title{
  width: 85px;
}
</style>
